import { createStore, Store, useStore as useVuexStore } from 'vuex'
import login from '@/store/login/login-store'
import system from '@/store/admin/system-store'
import { IRootState, IStoreType } from '@/store/types'
import { MenuInfoVO, RoleInfoVO, RouterVo } from '@/api/vo/user-vo'
import localCache from '@/utils/cache'
const store = createStore<IRootState>({
  state() {
    return {
      name: '张三',
      age: 23,
      entireRole: [],
      entireMenu: [],
      isCollapse: false,
      firstMenu: {}
    }
  },
  getters: {
    entireRole(state) {
      return state.entireRole
    },
    entireMenu(state) {
      return state.entireMenu
    },
    firstMenu(state) {
      return state.firstMenu
    }
  },
  mutations: {
    changeEntireRole(state, roleList: RoleInfoVO[]) {
      state.entireRole = roleList
    },
    changeEntireMenu(state, menuList: MenuInfoVO[]) {
      state.entireMenu = menuList
    },
    changeCollapse(state, isCollapse: boolean) {
      state.isCollapse = isCollapse
      localCache.setCache('isCollapse', isCollapse)
    },
    changeFirstMenu(state, firstMenu: RouterVo) {
      state.firstMenu = firstMenu
    }
  },
  actions: {
    async getInitialDataAction({ commit, dispatch }) {
      console.log()
    }
  },
  modules: {
    login,
    system
  }
})

export function setupStore() {
  store.dispatch('login/loadLocalLogin')
}

/*处理vuex的类型问题*/
export function useStore(): Store<IStoreType> {
  return useVuexStore()
}

export default store
